/**
 * Объект, содержащий наборы шагов для разных продуктовых туров.
 * Ключ объекта - идентификатор тура.
 * Значение - массив шагов для этого тура.
 */
export const tours = {
  // Основной тур, который запускается для новых пользователей
  main: [
    {
      target: 'body',
      content:
        'Добро пожаловать в Kotozapis! Давайте быстро пройдемся по основным функциям.',
      title: 'Приветствие',
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '#tour-step-calendar', // Селектор для пункта меню "Календарь"
      content:
        'Здесь находится ваш календарь записей. Управляйте своим расписанием с легкостью.',
      title: 'Календарь',
      disableBeacon: true,
      route: '/services', // После этого шага переходим на страницу "Услуги"
    },
    {
      target: '#tour-step-services', // Селектор для пункта меню "Услуги"
      content:
        'В этом разделе вы можете создавать и управлять вашими услугами, устанавливать цены и длительность.',
      title: 'Услуги',
      disableBeacon: true,
      route: '/account', // После этого шага переходим в "Настройки"
    },
    {
      target: '#tour-step-account-settings', // Селектор для меню пользователя или кнопки "Настройки"
      content:
        'Здесь вы можете настроить профиль вашей организации, указать адрес, загрузить фото и многое другое.',
      title: 'Настройки аккаунта',
      placement: 'left',
      disableBeacon: true,
    },
  ],
  // Пример тура для конкретной страницы
  calendar: [
    {
      target: '.fc-dayGridMonth-button', // Кнопка "Месяц" в календаре
      content: 'Переключайтесь между видами: месяц, неделя или день.',
      disableBeacon: true,
    },
    {
      target: '.fc-today-button', // Кнопка "Сегодня"
      content: 'Эта кнопка всегда вернет вас к текущей дате.',
      disableBeacon: true,
    },
  ],
  workingHours: [
    {
      target: 'body',
      content:
        'Давайте настроим ваш график работы. Это основа для онлайн-записи.',
      title: 'График работы',
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '#tour-wh-staff-select', // ID для селектора сотрудника
      content:
        'Сначала выберите сотрудника, для которого вы хотите настроить график.',
      disableBeacon: true,
    },
    {
      target: '#tour-wh-day-toggle', // ID для одного из переключателей дня недели
      content: 'Вы можете включать или отключать рабочие дни недели.',
      disableBeacon: true,
    },
    {
      target: '#tour-wh-add-interval', // ID для кнопки "Добавить интервал"
      content:
        'Для каждого рабочего дня можно задать один или несколько временных интервалов.',
      disableBeacon: true,
    },
    {
      target: '#tour-wh-save-button', // ID для кнопки "Сохранить график"
      content: 'После внесения изменений не забудьте сохранить график.',
      disableBeacon: true,
    },
  ],
}
